import { Injectable, LOCALE_ID, StaticClassProvider } from '@angular/core';
import { SharedLanguageService } from '../services/shared-language.service';


@Injectable({ providedIn: 'root' })
export class DynamicLocaleId extends String {
    constructor(protected service: SharedLanguageService) {
        super();
    }

    toString(): string {
        return this.service.getCurrentLocale();
    }

    valueOf(): string {
        return this.service.getCurrentLanguage();
    }
}

export const LocaleProvider: StaticClassProvider = {
    provide: LOCALE_ID,
    useClass: DynamicLocaleId,
    deps: [SharedLanguageService]
};
